<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close>
        <template #header>
          <h4 class="not-margin">
            Editar configuración
          </h4>
        </template>
        <div class="con-form">
          <vs-row>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" @input="changeInfo()">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template>
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar ciclo escolar" :key="cicloId" v-model="cicloEscolar">
                            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                Requerido
                            </template>
                            <template>
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="programa" class="labelInput">
                        Programa
                    </label>
                    <vs-select :loading="loadingPrograma" class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="nivel != ''" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('programa')">
                            Requerido
                        </template>
                        <template v-if="programas.length" autocomplete="off">
                            <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                    <div v-if="programa !== ''" @click="programa = ''" class="tache">
                        <i class="far fa-times-circle"></i>
                    </div>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="nivel" class="labelInput">
                        Nivel Académico
                    </label>
                    <vs-select :loading="loadingNivel" class="aqui pt-0" id="nivel" placeholder="Seleccionar Nivel Académico" :key="nivelId" v-model="nivel" :disabled="programa != ''">
                        <template #message-danger v-if="errorFields.includes('nivel')">
                            Requerido
                        </template>
                        <template v-if="niveles.length" autocomplete="off">
                            <vs-option v-for="option in niveles" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                    <div v-if="nivel !== ''" @click="nivel = ''" class="tache">
                        <i class="far fa-times-circle"></i>
                    </div>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Componente académico
                    </label>
                    <vs-select :loading="loadingComponente" class="aqui pt-0" id="institucion" placeholder="Seleccionar Componente académico" :key="componente_academicoId" v-model="componente_academico" :disabled="!componente_academicos.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('componente_academico')">
                            Requerido
                        </template>
                        <template v-if="componente_academicos.length" autocomplete="off">
                            <vs-option v-for="option in componente_academicos" :key="option.id"  :label="option.nombre" :value="option.id">
                                {{option.nombre}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Detalle Componente académico
                    </label>
                    <vs-select :loading="loadingDetalle" class="aqui pt-0" id="institucion" placeholder="Seleccionar Detalle Componente académico" :key="detalle_componente_academicoId" v-model="detalle_componente_academico" :disabled="!detalle_componente_academicos.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('detalle_componente_academico')">
                            Requerido
                        </template>
                        <template v-if="detalle_componente_academicos.length" autocomplete="off">
                            <vs-option v-for="option in detalle_componente_academicos" :key="option.id"  :label="option.nombre" :value="option.id">
                                {{option.nombre}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <!-- <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label class="labelInput">Boleta activa</label>
                    <vs-select placeholder="Boleta activa" v-model="activo_boleta" class="pl-0 pt-0">
                        <template #message-danger v-if="errorFields.includes('activo_boleta')">
                            Requerido
                        </template>
                        <vs-option label="Si" value="si">
                            Si
                        </vs-option>
                        <vs-option label="No" value="no">
                            No
                        </vs-option>
                    </vs-select>
                </form>
            </vs-col> -->
            
            <vs-col sm="12" class="mt-3">
                <h5>Rango de fechas de visualización</h5>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label class="labelInput">Fecha de inicio</label>
                    <vs-input
                        type="date"
                        v-model="fecha_inicio"
                        class="pl-0 pt-0"
                    >
                        <template #message-danger v-if="errorFields.includes('fecha_inicio')">
                            Requerido
                        </template>
                    </vs-input>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label class="labelInput">Fecha final</label>
                    <vs-input
                        type="date"
                        v-model="fecha_fin"
                        :min="fecha_inicio"
                        class="pl-0 pt-0"
                    >
                        <template #message-danger v-if="errorFields.includes('fecha_fin')">
                            Requerido
                        </template>
                    </vs-input>
                </form>
            </vs-col>
          </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog">
            <vs-row>
                  <vs-col lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false"
                        style="width: 50%"
                    >
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col lg="6">
                    <vs-button
                        success
                        @click="postCrearConfiguracionBoleta()"
                        style="width: 50%"
                        class="ml-auto"
                    >
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico.js'
    export default {
        props:[
            'value',
            'row',
        ],
      data:() => ({
        active: false,
        institucion: '',
        instituciones: [],
        institucionId: (new Date()).getTime(),
        cicloEscolar: '',
        ciclosEscolares: '',
        cicloId: (new Date()).getTime(),
        fecha_inicio: '',
        fecha_fin: '',
        activo_boleta: '',
        componente_academico: '',
        componente_academicos: [],
        componente_academicoId: (new Date()).getTime(),
        detalle_componente_academico: '',
        detalle_componente_academicos: [],
        detalle_componente_academicoId: (new Date()).getTime(),
        errorFields: [],
        loadingCiclo: false,
        loadingInstituto: false,
        loadingComponente: false,
        loadingDetalle: false,
        programa: '',
        programas: [],
        programaId: (new Date()).getTime(),
        nivel: '',
        niveles: [],
        nivelId: (new Date()).getTime(),
        loadingPrograma: false,
        loadingNivel: false,
      }),
    methods: {
        getRefrescar(){
            this.cicloEscolar = ''
            this.componente_academico = ''
            this.detalle_componente_academico = ''
        },
        getInfo(){
            this.institucion = this.row.institucion_id
            this.cicloEscolar = this.row.ciclo_escolar_id
            if(this.row.programa_id != '' && this.row.programa_id != null){
                this.nivel = ''
                this.programa = this.row.programa_id
            }
            if(this.row.nivel_academico_id != '' && this.row.nivel_academico_id != null){
                this.programa = ''
                this.nivel = this.row.nivel_academico_id
            }
            this.componente_academico = this.row.componente_academico_id
            this.detalle_componente_academico = this.row.detalle_componente_academico_id
            this.activo_boleta = this.row.activo_boleta
            this.fecha_inicio = this.row.fecha_inicio
            this.fecha_fin = this.row.fecha_fin
        },
        changeInfo(){
            this.programa = ''
            this.nivel = ''
            this.componente_academico = ''
            this.detalle_componente_academico = ''
            this.cicloEscolar = ''
        },
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await academico.getInstitucion()
                this.loadingInstituto = false
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
            }
            catch{
                
            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.loadingCiclo = true
                const { data: response } = await academico.getCiclosEscolares(this.institucion)
                this.loadingCiclo = false
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
            }
        },
        async getPrograma() {
            if(this.institucion){
                this.loadingPrograma = true
                const { data: response } = await academico.getPrograma(this.institucion)
                this.programas = response
                this.programaId = (new Date()).getTime()
                this.loadingPrograma = false
            }
        },
        async getNivelAcademico() {
            if(this.institucion){
                this.loadingNivel = true
                const params = {
                    "institucion_id": this.institucion
                }
                const { data: response } = await academico.getNivelAcademico(params)
                this.niveles = response
                this.nivelId = (new Date()).getTime()
                this.loadingNivel = false
            }
        },
        async getComponenteAcademico() {
            if(this.cicloEscolar){
                let params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar
                }
                const { data: response } = await academico.getComponenteAcademico(params)
                this.componente_academicos = response
                this.componente_academicoId = (new Date()).getTime()
            }
        },
        async getDetalleComponenteAcademico() {
            if(this.componente_academico){
                let params = {
                    componente_academico_id: this.componente_academico,
                }
                this.loadingDetalle = true
                const { data: response } = await academico.getDetalleComponenteAcademico(params)
                this.loadingDetalle = false
                this.detalle_componente_academicos = response
                this.detalle_componente_academicoId = (new Date()).getTime()
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('number', this.cicloEscolar)) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.checkByType ('number', parseInt(this.institucion))) {
                this.errorFields.push('institucion')
            }
            if(this.nivel == ''){
                if (!this.checkByType ('number', parseInt(this.programa))) {
                    this.errorFields.push('programa')
                }
            }
            if(this.programa == ''){
                if (!this.checkByType ('number', parseInt(this.nivel))) {
                    this.errorFields.push('nivel')
                }
            }
            if (!this.checkByType ('number', parseInt(this.componente_academico))) {
                this.errorFields.push('componente_academico')
            }
            if (!this.checkByType ('number', parseInt(this.detalle_componente_academico))) {
                this.errorFields.push('detalle_componente_academico')
            }
            // if (!this.checkByType ('number', parseInt(this.activo_boleta))) {
            //     this.errorFields.push('activo_boleta')
            // }
            if (!this.checkByType ('number', parseInt(this.fecha_inicio))) {
                this.errorFields.push('fecha_inicio')
            }
            if (!this.checkByType ('number', parseInt(this.fecha_fin))) {
                this.errorFields.push('fecha_fin')
            }
            if (!this.errorFields.length){
                return {
                    configuracion_boleta_id: this.row.configuracion_boleta_id,
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    programa_id: this.programa,
                    nivel_academico_id: this.nivel,
                    detalle_componente_academico_id: this.detalle_componente_academico,
                    fecha_inicio: this.fecha_inicio,
                    fecha_fin: this.fecha_fin
                }
            } else {
                return null
            }
        },
        async postCrearConfiguracionBoleta(){
            const datos = this.sanityForm()
            if(datos){
                const loading = this.$vs.loading()
                try{
                    const { data: response } = await academico.postCrearConfiguracionBoleta(datos)
                    this.$emit('refreshTable', this.institucion, this.cicloEscolar, this.programa)
                    loading.close()
                    this.getCancelar()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se edito con éxito el registro.'
                    })
                } catch{
                    loading.close()
                    this.getCancelar()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un error.',
                        text: 'Por favor contactar al administrador.'
                    })
                }
            }
        },
        getCancelar(){
            this.active = false
            this.institucion_id = ''
            this.ciclo_escolar_id = ''
            this.componente_academico = ''
            this.detalle_componente_academico = ''
            this.activo_boleta = ''
            this.fecha_inicio = ''
            this.fecha_fin = ''
        }
    },
    watch: {
        value (val) {
            this.active = val
            this.getInstituciones()
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        institucion(){
            this.getCicloEscolar()
            this.getPrograma()
            this.getNivelAcademico()
        },
        cicloEscolar(){
            this.getComponenteAcademico()
        },
        componente_academico(){
            this.getDetalleComponenteAcademico()
        },
        row(){
            this.getInfo()
        },
    }
    }
</script>

<style>
label{
    margin-bottom: 0;
}
</style>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>
